import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from 'hooks/auth'
import api from 'helpers/api'
import { safeLocalStorage } from 'helpers/localStorage'
import TwoFactorCodeForm, { IFormValues } from 'views/auth/components/TwoFactorCodeForm'
import { HOME } from 'routes'
import { useApplicationStore } from 'hooks/application'
import { SIGNIN_EMAIL_KEY } from 'app-constants'
import { redirectTo } from 'helpers/redirect'
import { clearMasqueradeToken, clearLoggedOutFlag } from 'helpers/auth'

const TwoFactorLogin: React.FC = () => {
  const { updateUser } = useAuth()
  const { displayErrorMessage } = useApplicationStore()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const loginToken = searchParams.get('loginToken')

  const handleSubmit = async (values: IFormValues) => {
    try {
      const response = await api.loginWith2Fa(values.code, loginToken!)
      clearMasqueradeToken()
      // Release the forced-logout latch so updateUser can persist the new session.
      clearLoggedOutFlag()
      await updateUser(response.data)
      safeLocalStorage.setItem(SIGNIN_EMAIL_KEY, response.data.email.toLowerCase())
      navigate(redirectTo(HOME))
    } catch (e) {
      displayErrorMessage(e)
    }
  }

  return (
    <div className="bg-really-light-blue flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-8">
      <div className="h-fit flex flex-col bg-surface border border-divider-strong p-8 shadow-heavy rounded text-body w-[550px]">
        <h1 className="mb-12 text-2xl">Enter your 2FA code</h1>
        <p>Use the authenticator device associated with your account to generate your 2FA code</p>
        <br />
        <TwoFactorCodeForm onSubmit={handleSubmit} />
      </div>
    </div>
  )
}

export default TwoFactorLogin
